// Package Imports
import { toJS } from "mobx";

// Package Imports
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";

const updateChangeProductDataStructure = (changeProductDetails,newSelectedProduct) => {
  let productListData = toJS(OptimizationStore.product_list_data);

  productListData.map((item) => {
    if (item.need_unique_name === changeProductDetails.cardKey) {
      item.data.map((product, productIndex) => {
        if (
          !Array.isArray(product.BI) &&
          product.family_product_id ===
            changeProductDetails.data.family_product_id
        ) {
          product.BI = {
            risk: "high",
            BI: {},
            bi_request: {},
            update_BI: false,
          };
          product.isErrorExist = false.
          product.update_BI = false;
        }

        if (Array.isArray(product.BI)) {
          product.BI.map((biData, biIndex) => {
            if (
              biData.risk === newSelectedProduct.risk &&
              biData.family_product_id ===
                changeProductDetails.data.family_product_id
            ) {
              product.BI[biIndex] = {
                risk: newSelectedProduct.risk,
                BI: {},
                bi_request: {},
                update_BI: false,
              };
            }
            return biData;
          });
        }

        if (product.family_product_id === newSelectedProduct.family_product_id) {
          product.selectedRisk = newSelectedProduct.risk,
          product.selected_risk_type = newSelectedProduct.risk
        }

      });
    }
    return item;
  });
  OptimizationStore.product_list_data = [...productListData];
};

export default updateChangeProductDataStructure;
